import { z } from "zod";
import { BaseAnalyticsEvent } from "./base";
// Whenever a user signs in
export const Team_MemberInvite = BaseAnalyticsEvent.extend({
    name: z.literal("Team_MemberInvite")
});
